<template>
  <div v-if="!$store.getters['user/isLister']">
    <a class="interactive" :class="classes" @click="handleClick">
      {{ label }}
    </a>
  </div>
</template>

<script>
export default {
  props: {
    classes: {
      type: String,
      required: false,
      default: "button",
    },
    label: {
      type: String,
      required: false,
      default: "Find your space",
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    handleClick() {
      if (!window.location.href.includes("#find-your-space-today")) {
        window.history.pushState(
          "state obj or string",
          "url",
          window.location.href + "#find-your-space-today"
        );
      }
      this.$store.commit("findspace/show");
    },
  }
}
</script>
